import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { auth, checkIsAdmin } from '../lib/firebase';
import Loading from './Loading';
import ErrorBoundary from './ErrorBoundary';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const [authState, setAuthState] = useState<'loading' | 'authenticated' | 'unauthenticated'>('loading');
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        setAuthState('unauthenticated');
        return;
      }

      try {
        const isAdmin = await checkIsAdmin(user.uid);
        setAuthState(isAdmin ? 'authenticated' : 'unauthenticated');
      } catch (error) {
        console.error('Error checking admin status:', error);
        setAuthState('unauthenticated');
      }
    });

    return () => unsubscribe();
  }, []);

  if (authState === 'loading') {
    return <Loading message="Verificando permisos..." priority />;
  }

  if (authState === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default ProtectedRoute;